const getLoader = require('prismjs/dependencies');
const components = require('prismjs/components');
const componentsToLoad = ['bash','php', 'css', 'javascript', 'json'];
const loader = getLoader(components, componentsToLoad, loadedComponents);
loader.load(id => {
    require(`prismjs/components/prism-${id}.min.js`);
});

const loadedComponents = ['clike', 'bash','php', 'css', 'javascript', 'json'];
